if (!customElements.get('header-language-selector')) {
  class HeaderLanguageSelector extends HTMLElement {
    connectedCallback() {
      this.breakpointHandler = this.breakpointHandler || this.move.bind(this);
      this.documentClickHandler = this.documentClickHandler || this.handleDocumentClick.bind(this);
      window.addEventListener('on:breakpoint-change', this.breakpointHandler);
      document.addEventListener('click', this.documentClickHandler);
      this.move();
    }

    disconnectedCallback() {
      window.removeEventListener('on:breakpoint-change', this.breakpointHandler);
      document.removeEventListener('click', this.documentClickHandler);
    }

    move() {
      const desktopSlot = document.querySelector('[data-header-language-desktop]');
      const menu = document.querySelector('.main-menu__content');
      let mobileSlot = document.querySelector('[data-header-language-mobile]');

      if (!desktopSlot || !menu) return;

      if (theme.mediaMatches.md) {
        if (this.parentElement !== desktopSlot) desktopSlot.appendChild(this);
        if (mobileSlot) mobileSlot.remove();
        return;
      }

      if (!mobileSlot) {
        mobileSlot = document.createElement('div');
        mobileSlot.classList.add('header-language-selector__mobile');
        mobileSlot.setAttribute('data-header-language-mobile', '');
        menu.appendChild(mobileSlot);
      }

      if (this.parentElement !== mobileSlot) mobileSlot.appendChild(this);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.querySelector('details')?.removeAttribute('open');
      }
    }
  }

  customElements.define('header-language-selector', HeaderLanguageSelector);
}
